import Navbar from "@/pages/home/components/Navbar";
import PageBanner from "@/pages/home/components/PageBanner";
import RevenueModels from "@/pages/home/components/RevenueModels";
import Footer from "@/pages/home/components/Footer";
import CmsPage from "@/components/cms/CmsPage";
import EnquiryForm from "@/components/feature/EnquiryForm";
import { DESTINATION_NAMES } from "@/pages/public/destinations/data";

export default function ModelsPage() {
  return (
    <main className="w-full">
      <Navbar />
      <CmsPage slug="models" path="/models" fallbackSeo={{ title: "Revenue Models | NOMADLIVINGS", description: "Pick the revenue model that best matches your financial goals — professionally structured for hassle-free villa ownership." }}>
      <PageBanner
        eyebrow="Revenue Models"
        title="Choose How You"
        highlight="Earn"
        subtitle="Pick the revenue model that best matches your financial goals — every option is professionally structured for hassle-free villa ownership."
        image="https://readdy.ai/api/search-image?query=Luxury%20A-frame%20villa%20partnership%20concept%20with%20architectural%20blueprints%20and%20property%20investment%20documents%20on%20a%20wooden%20table%2C%20warm%20natural%20light%2C%20hospitality%20investment%20and%20partnership%20theme%2C%20warm%20amber%20tones%2C%20professional%20photography&width=1800&height=900&seq=banner-models-x2&orientation=landscape&nocache=true"
        imageAlt="Hospitality villa partnership and investment concept"
        ctaLabel="Schedule a Site Visit"
        ctaTo="/contact"
      />
      <RevenueModels />
      </CmsPage>

      <section className="w-full py-16 md:py-20 bg-background-50">
        <div className="w-full px-4 md:px-8 max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-start">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.2em] uppercase text-primary-600">
              <i className="ri-calculator-line"></i> Which Model Fits You?
            </span>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mt-4 leading-tight">
              Get a Personal <span className="italic text-primary-700">Returns Plan</span>
            </h2>
            <p className="text-foreground-600 text-sm md:text-base mt-4 leading-relaxed">
              Tell us your budget and preferred earning style — profit-sharing or fixed minimum
              rental — and we'll prepare a tailored returns projection for the villa model you
              choose.
            </p>
            <div className="mt-8 grid grid-cols-2 gap-4">
              {[
                { icon: "ri-percent-line", label: "Profit Sharing" },
                { icon: "ri-shield-check-line", label: "Minimum Rental" },
                { icon: "ri-line-chart-line", label: "28–40% ROI" },
                { icon: "ri-hand-coin-line", label: "Flexible Budget" },
              ].map((s) => (
                <div key={s.label} className="flex items-center gap-3 rounded-2xl bg-background-100 border border-background-200 p-4">
                  <span className="flex items-center justify-center w-10 h-10 rounded-full bg-accent-100 text-accent-700 shrink-0">
                    <i className={`${s.icon} text-lg`}></i>
                  </span>
                  <p className="text-sm font-semibold text-foreground-800">{s.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="rounded-3xl bg-background-100 border border-background-200 p-5 md:p-8">
            <EnquiryForm
              page="models"
              title="Enquire About a Villa Model"
              subtitle="A specialist will walk you through each revenue model and your projected returns."
              interestOptions={[
                "Staycation / Weekend Villa",
                "Airbnb / Short-Term Rental",
                "Boutique Resort Villa",
                "Holiday Home",
                "NRI Passive Income",
                "Not sure yet",
              ]}
              modelOptions={["Profit Sharing Model", "Minimum Rental Model"]}
              destinationOptions={DESTINATION_NAMES}
              ctaLabel="Get My Returns Plan"
              accent
            />
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}